<template>
  <v-dialog :value="dialog" @input="$emit('input', $event)" max-width="500">
    <v-card>
      <v-card-title class="error white--text">
        <v-icon left color="white">mdi-alert-circle</v-icon>
        SOPORTE DE EMERGENCIA
      </v-card-title>

      <v-card-text class="pa-6">
        <p class="mb-4"><strong>¿Estás experimentando una emergencia técnica?</strong></p>
        <p>
          Nuestro equipo de soporte está disponible 24/7 para ayudarte inmediatamente.
        </p>

        <div class="emergency-actions mt-6">
          <v-btn
            color="green darken-2"
            dark
            block
            large
            @click="$emit('whatsapp')"
            class="mb-3"
          >
            <v-icon left>mdi-whatsapp</v-icon>
            EMERGENCIA POR WHATSAPP
          </v-btn>

          <v-btn color="red" dark block large @click="$emit('call')" class="mb-3">
            <v-icon left>mdi-phone</v-icon>
            LLAMAR DE EMERGENCIA
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EmergencyModal",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["input", "whatsapp", "call"],
};
</script>

<style scoped>
.emergency-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
